export default {
  name: "Index"
};